import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { useAuthStore } from '../../stores/authStore';

const Register = () => {
  const navigate = useNavigate();
  const { isAuthenticated } = useAuthStore();
  const { t } = useTranslation(['auth']);
  
  useEffect(() => {
    if (isAuthenticated) {
      navigate('/');
    } else {
      navigate('/login?mode=register');
    }
  }, [isAuthenticated, navigate]);
  
  return (
    <div style={{ 
      display: 'flex', 
      justifyContent: 'center', 
      alignItems: 'center', 
      height: '100vh',
      background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
      color: '#fff',
      fontSize: '18px'
    }}>
      {t('auth:register.title', { defaultValue: 'Register' })}...
    </div>
  );
};

export default Register;
